import './ListingItem.css';
import React from 'react';
import { getGlobalDictionaryTerm, getMediaHost, injectImageResolution, pathJoin } from '../../../../utils';
import LazyPicture from '../../LazyPicture';
import FavouriteBtn from '../../FavouriteBtn/FavouriteBtn';
import RouterLink from '../../RouterLink';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../../utils/tealium';
import { SitecoreContextReactContext } from '../../../../utils/SitecoreContextReactContext';
import { HighlighterHOC } from '../../HighlighterHOC/HighlighterHOC';
var ListingItem = function ListingItem(_ref) {
  var item = _ref.item,
    rtl = _ref.rtl,
    color = _ref.color,
    isActiveItem = _ref.isActiveItem,
    analytics = _ref.analytics,
    params = _ref.params,
    getActivePopupOnMap = _ref.getActivePopupOnMap,
    isCarousel = _ref.isCarousel,
    activeTopPicks = _ref.activeTopPicks,
    toggleActiveTopPicks = _ref.toggleActiveTopPicks,
    _ref$withHighlightTex = _ref.withHighlightText,
    withHighlightText = _ref$withHighlightTex === void 0 ? false : _ref$withHighlightTex,
    _ref$searchString = _ref.searchString,
    searchString = _ref$searchString === void 0 ? '' : _ref$searchString;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var addToFavorites = getGlobalDictionaryTerm(sitecoreContext, 'addToFavorites') || 'add To Favorites';
  var removeFromFavorites = getGlobalDictionaryTerm(sitecoreContext, 'removeFromFavorites') || 'remove from Favorites';
  var objectID = item.objectID,
    _item$image = item.image,
    image = _item$image === void 0 ? '' : _item$image,
    title = item.title,
    englishTitle = item.englishTitle,
    url = item.url,
    type = item.type,
    tripadvisorImage = item.tripadvisorImage,
    tripadvisorReviews = item.tripadvisorReviews,
    tripadvisorScore = item.tripadvisorScore,
    lng = item._geoloc.lng,
    lat = item._geoloc.lat;
  var formatNum = function formatNum(n) {
    return n >= 1000 ? "".concat((n / 1000).toFixed(1), "\u041A") : "".concat(n);
  };
  var imgSrc = injectImageResolution("".concat(pathJoin([getMediaHost(), image])), 75, 56);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "imfilters-listing-item ".concat(isActiveItem ? 'active' : ''),
    style: {
      '--m114-listing-item-color': color
    }
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "imfilters-listing-item__image",
    src: imgSrc,
    alt: title || englishTitle,
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement("div", {
    className: "imfilters-listing-item__info"
  }, isCarousel ? /*#__PURE__*/React.createElement(React.Fragment, null, (title || englishTitle) && /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    href: url,
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(analytics['selectedItemAnalytics'], params), [type, title || englishTitle]);
    },
    title: title,
    className: "title ".concat(isCarousel ? 'ellipsis1' : 'ellipsis2')
  }, title || englishTitle)) : /*#__PURE__*/React.createElement(React.Fragment, null, (title || englishTitle) && /*#__PURE__*/React.createElement("button", {
    type: "button",
    name: title || englishTitle,
    onClick: function onClick() {
      getActivePopupOnMap({
        objectID: objectID,
        lat: lat,
        lng: lng
      });
      tealiumClickFunc(tealiumMergeClickData(analytics['selectedItemAnalytics'], params), [type, title || englishTitle]);
    },
    title: title,
    className: "title ".concat(isCarousel ? 'ellipsis1' : 'ellipsis2')
  }, withHighlightText ? /*#__PURE__*/React.createElement(HighlighterHOC, {
    text: title,
    searchString: searchString
  }) : title || englishTitle)), /*#__PURE__*/React.createElement("div", {
    className: "imfilters-listing-item__tripadvisor"
  }, tripadvisorImage && /*#__PURE__*/React.createElement("div", {
    className: "tripadvisor-svg"
  }, /*#__PURE__*/React.createElement("img", {
    src: tripadvisorImage,
    alt: title || englishTitle,
    "aria-hidden": "true"
  })), tripadvisorReviews && /*#__PURE__*/React.createElement("span", {
    className: "tripadvisor-num"
  }, formatNum(Number(tripadvisorReviews))))), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: objectID,
    classes: 'imfilters-listing-item__fav-btn',
    activeListOnSamePage: activeTopPicks,
    multiplyButton: true,
    analyticsClick: function analyticsClick(e) {
      if (e === 'add to favorites') {
        tealiumClickFunc(tealiumMergeClickData(analytics['favoriteAnalytics'], params), ["".concat(type, " : ").concat(title || englishTitle), "".concat(addToFavorites)]);
      } else {
        tealiumClickFunc(tealiumMergeClickData(analytics['favoriteAnalytics'], params), ["".concat(type, " : ").concat(title || englishTitle), "".concat(removeFromFavorites)]);
      }
      toggleActiveTopPicks(objectID);
    }
  })));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: " ".concat(commonStyles, "  ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "c11arr7l";
var ltrStyles = "l1ql5y0";
var rtlStyles = "rgujfd8";
export default ListingItem;